const MILLISECONDS_PER_SECOND = 1000
const SECONDS_PER_MINUTE = 60
const MINUTES_PER_HOUR = 60
const HOURS_PER_DAY = 24

export const generateMiliSecondsByMinutes = (minutes: number) =>
  minutes * SECONDS_PER_MINUTE * MILLISECONDS_PER_SECOND

export const generateMiliSecondsByHours = (hours: number) =>
  hours * MINUTES_PER_HOUR * SECONDS_PER_MINUTE * MILLISECONDS_PER_SECOND

export const generateMiliSecondsByDays = (days: number) =>
  days *
  HOURS_PER_DAY *
  MINUTES_PER_HOUR *
  SECONDS_PER_MINUTE *
  MILLISECONDS_PER_SECOND

export const calculateElapsedDays = (dateFrom: Date) => {
  const dateTo = new Date()
  const diffTime = Math.abs(dateTo.getTime() - dateFrom.getTime())
  return Math.ceil(diffTime / (HOURS_PER_DAY * MINUTES_PER_HOUR * SECONDS_PER_MINUTE * MILLISECONDS_PER_SECOND))
}
